import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/wellbet/images/logo.svg';

export default function Index() {
  return <Image src={logo} maxW="165px" ml="2" />;
}
